import { render } from "./ActivePriceDetail.vue?vue&type=template&id=270d19fe&ts=true"
import script from "@/composables/pages/price/active-price/ActivePriceDetailComposable.ts?vue&type=script&lang=ts"
export * from "@/composables/pages/price/active-price/ActivePriceDetailComposable.ts?vue&type=script&lang=ts"

import "./ActivePriceDetail.vue?vue&type=style&index=0&id=270d19fe&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__